import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="py-24 px-4 bg-[#111827] relative overflow-hidden" data-id="element-168">
      {/* Glow behind pricing card */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#c9a84c]/10 rounded-full blur-[120px] pointer-events-none" data-id="element-169" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-170">
        <FadeIn data-id="element-171">
          <div className="text-center mb-10" data-id="element-172">
            <h2 className="text-3xl md:text-4xl font-bold text-[#f5f5f5] mb-6" data-id="element-173">
              No vas apagar $25.50 que costará este programa el mes que viene.
            </h2>
            <p className="text-xl text-[#9ca3af]" data-id="element-174">
              Porque sé que el hombre latino necesita soluciones reales y
              accesibles, hoy puedes descargarlo por:
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-175">
          <div id="comprar" className="bg-[#0a0e1a] border-2 border-[#c9a84c] rounded-3xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(201,168,76,0.2)] max-w-2xl mx-auto" data-id="element-176">
            <div className="inline-block bg-[#dc2626] text-white font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider mb-6 animate-pulse" data-id="element-177">
              Oferta Especial Limitada
            </div>

            <div className="flex justify-center items-center gap-4 mb-4" data-id="element-178">
              <span className="text-3xl text-[#9ca3af] line-through decoration-[#dc2626] decoration-4" data-id="element-179">
                $25.50
              </span>
              <span className="text-6xl md:text-8xl font-extrabold text-[#c9a84c]" data-id="element-180">
                $6.36
              </span>
              <span className="text-xl text-[#9ca3af] font-bold mt-4" data-id="element-181">USD</span>
            </div>

            <p className="text-[#f5f5f5] font-medium mb-8 text-lg" data-id="element-182">
              (Pago único, acceso de por vida)
            </p>

            <Button href="https://www.tumomentovital.com/cart/47616565608640:1" onClick={() => {
            if ((window as any).fbq) {
              ;
              (window as any).fbq('track', 'AddToCart');
            }
          }} className="w-full text-xl py-6 mb-6 shadow-[0_0_30px_rgba(201,168,76,0.4)]" data-id="element-183">
              SÍ, QUIERO RECUPERAR MI ENERGÍA AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-[#9ca3af]" data-id="element-184">
              <div className="flex items-center gap-2" data-id="element-185">
                <ShieldCheckIcon className="w-5 h-5 text-[#c9a84c]" data-id="element-186" />
                <span data-id="element-187">Garantía de 7 Días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-188">
                <LockIcon className="w-5 h-5 text-[#c9a84c]" data-id="element-189" />
                <span data-id="element-190">Pago 100% Seguro</span>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-191">
          <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-192">
            <p className="text-[#9ca3af] italic" data-id="element-193">
              <strong className="text-[#f5f5f5]" data-id="element-194">¿Por qué tan barato?</strong>{' '}
              Porque prefiero tener 10,000 hombres recuperando su vida y
              recomendando este método, que a unos pocos pagando precios
              excesivos. Pero este precio solo es válido para los{' '}
              <strong className="text-[#dc2626]" data-id="element-195">
                siguientes 50 compradores
              </strong>
              .
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}